import { IQuoteInverter, Inverter } from "@design/models/inverter.model";
import { Update } from "@ngrx/entity";
import { createAction, props } from "@ngrx/store";

export namespace fromInverterActions {

  export const AddInverter = createAction(
      '[Inverter Configuration] add inverter to quote',
      props<{ inverter: Inverter}>()
  );

  export const AddInverters = createAction(
    '[Inverter Configuration] add inverters to quote',
    props<{ inverters: Inverter[] }>()
  );

  // export const UpdateInverter = createAction(
  //   '[Inverter Configuration] update inverter of the quote',
  //   props<{ inverter: Update<Inverter> }>()
  // );


  export const UpdateInverter = createAction(
    '[Inverter Configuration] update inverter of the quote',
    props<{ inverter: Inverter }>()
  );
  
  export const DeleteInverter = createAction(
    '[Inverter Configuration] delete inverter from the quote',
    props<{ inverterId: string }>()
  );

  export const SetDcAcRatio = createAction(
    '[Inverter Configuration] set dc to ac ratio to store from quote api',
    props<{ dcAcRatio: number }>()
  );

  export const UpdateDcAcRatio = createAction(
    '[Inverter Configuration] update dc to ac ratio of the quote',
    props<{ dcAcRatio: number }>()
  );

  export const UpdateEfficiency = createAction(
    '[Inverter Configuration] update efficiency for an inverter of the quote',
    props<{ efficiency: number }>()
  );

  export const SetEfficiency = createAction(
    '[Inverter Configuration] Set efficiency of inverters to store from quote api',
    props<{ efficiency: number }>()
  );
  export const UpdateAddedCapacity = createAction(
    '[Inverter Configuration] update added capacity for an inverter of the quote',
    props<{ addedCapacity: number }>()
  );

  export const SaveInverters = createAction('[Inverter Configuration] save inverter data to quote');

  export const SaveInvertersSuccess = createAction(
    '[Inverter Configuration] save inverter data to quote Success',
    props<{ inverter: IQuoteInverter }>()
  );

  export const SaveInvertersFailure = createAction(
    '[Inverter Configuration] save inverter data to quote failure',
    props<{ error: any  }>()
  );

  export const InverterCopied = createAction(
    '[Inverter Configuration] Inverter copy or add triggered'
  );

  export const RecheckAddedInvertor = createAction(
    '[Inverter Configuration] retry invertor update status'

  );

}
